import { useState } from "react";
import fetcher from "../../../helper/fetcher";
import { useSnackbar } from "../../../context/SnackBarContext";
import { useNavigate } from "react-router-dom";

export const CrmUseAddProduct = () => {
    const [formData, setFormData] = useState({
        productName: "",
        productCode: "",
        hsnORsacCode: "",
        productUnit: "",
        availableStock: "",
        // mrp: "",
        salePrice: "",
        discountPercentage: "",
        purchasePrice: "",
        gstRate: "",
    });
    const [isLoading, setIsLoading] = useState(false);
    const { showSuccess, showError } = useSnackbar();
    const navigate = useNavigate()
    const productUnits = ["Pieces", "Kg", "Meter", "Box", "Packet"];
    const gstRates = ["0", "5", "12", "18", "28"];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const generateCode = () => {
        const randomCode = Math.floor(100000 + Math.random() * 900000);
        setFormData((prev) => ({ ...prev, productCode: randomCode }));
    };

    const validate = () => {
        if (!formData.productName.trim()) {
            showError("Product Name is required");
            return false;
        }
        if (!formData.hsnORsacCode.trim()) {
            showError("HSN/SAC Code is required");
            return false;
        }
        if (!formData.productUnit) {
            showError("Product Unit is required");
            return false;
        }
        if (!formData.gstRate) {
            showError("GST Rate is required");
            return false;
        }
        if (!formData.availableStock) {
            showError("Available Stock is required");
            return false;
        }
        if (!formData.salePrice || Number(formData.salePrice) <= 0) {
            showError("Enter a valid Sale Price");
            return false;
        }

        if (
            formData.discountPercentage &&
            (Number(formData.discountPercentage) < 0 ||
                Number(formData.discountPercentage) > 100)
        ) {
            showError("Discount must be between 0 - 100%");
            return false;
        }
        return true;
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validate()) return;

        setIsLoading(true);

        fetcher
            .post("/crm/product/create_product", formData)
            .then(() => {
                showSuccess("Created successfully");
                setFormData({
                    productName: "",
                    productCode: "",
                    hsnORsacCode: "",
                    productUnit: "",
                    availableStock: "",
                    // mrp: "",
                    salePrice: "",
                    discountPercentage: "",
                    purchasePrice: "",
                    gstRate: "",
                });
                navigate('/crm/manage-product')

            })
            .catch((error) => {
                showError(error.response?.data?.message || "Some Error Occured");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return {
        formData,
        handleChange,
        handleSubmit,
        productUnits,
        gstRates,
        generateCode,
        isLoading,
    };
};
